<template>
    <validation-observer>
        <b-alert v-if="message.status == 'Error'" show variant="danger">
            <h4 class="alert-heading"> {{$t('general.error')}} </h4>
            <p>
                {{errMsg}}
            </p>
            <hr>
            <p class="mb-0">
                {{message.message}}
            </p>
        </b-alert>
        <form ref="form" class="menuForm">
            <b-form-group class="inputGrp" :label="$t('user.menus.menuList')" label-for="country">
                <b-form-select 
                    class="select"
                    v-model="selectedMenus"
                    text-field="menu_detail[0].title"
                    value-field="id"
                    :options="menus"
                    :select-size="10"
                    multiple
                />
               
            </b-form-group>
            
            <div class="buttons">
                <b-button :title="$t('user.menus.transferAll')" size="sm" variant="outline-primary"> <b-icon icon="chevron-double-right"> </b-icon>  </b-button> 
                <b-button :title="$t('user.menus.transferSelecteds')" size="sm" variant="outline-primary" > <b-icon icon="chevron-right" ></b-icon>  </b-button>
                <b-button :title="$t('user.menus.removeSelecteds')" size="sm" variant="outline-primary"> <b-icon icon="chevron-left"></b-icon> </b-button> 
                <b-button :title="$t('user.menus.removeAll')" size="sm" variant="outline-primary"> <b-icon icon="chevron-double-right"> </b-icon>  </b-button> 
            </div>

            <b-form-group class="inputGrp" :label="$t('user.menus.authMenuList')" label-for="country">
                <b-form-select 
                    class="select"
                    v-model="selectedCountry"
                    text-field="name"
                    value-field="country_id"
                    :options="countries"
                    :select-size="10"
                />
               
            </b-form-group>
        </form>
    </validation-observer>
    
</template>

<script>
    import i18n from '@/plugins/i18n';

    export default {
        name: "Users",
        created: async function(){
            await this.$store.dispatch('listUserMenu')
        },
        methods: {
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            }
        },
        watch: {
            save: function(data){
                if(data){
                    this.$refs.Users.validate().then(success =>{
                        //Düzenlenecek
                            if(success){
                                if(this.modalName == "add"){
                                    let data = {
                                        customerId: this.$route.params.id,
                                        name: this.name,
                                        phone_no: this.phone_no,
                                        email: this.email,
                                        task: this.task
                                    }
                                    this.$store.dispatch('addUserCustomer', data)
                                    if(this.message.status == "Success"){
                                        this.$store.dispatch('getCustomerContacts', {id: this.$route.params.id})
                                        this.saveState(false)
                                        this.modalEvent(false)
                                        this.selectedMenus = []
                                        this.phone_no = ""
                                        this.email = ""
                                        this.task = ""
                                    }else{
                                        this.errMsg = i18n.t('customer.users.addErrMsg')
                                    }
                                }else{
                                    let data = {
                                        customerId: this.$route.params.id,
                                        userId: this.data.ID,
                                        name: this.name,
                                        phone_no: this.phone_no,
                                        email: this.email,
                                        task: this.task
                                    }
                                    this.$store.dispatch('updateUserCustomer', data)
                                    if(this.message.status == "Success"){
                                        this.$store.dispatch('getCustomerContacts', {id: this.$route.params.id})
                                        this.saveState(false)
                                        this.modalEvent(false)
                                    }else{
                                        this.errMsg = i18n.t('customer.users.editErrMsg')
                                    }
                                }
                            }
                        }
                    )
                }
                this.saveState(false)
                
            }
        },
        computed: {
            loading(){
                return this.$store.getters.getLoading
            },
            message(){
                return this.$store.getters.getCustomerContactInfo
            },
            menus(){
                return this.$store.getters.getUserMenus

            }
        },
        data: function(){
            return{
                selectedMenus: [],
                phone_no: this.data ? this.data.phone_no : "",
                email: this.data ? this.data.email : "",
                task: this.data ? this.data.task : "",
                errMsg: "",
            }
        },
        props:{
            data: Array,
            changeData: Function,
            save: Boolean,
            saveState: Function,
            modalName: String,
            modalEvent: Function,
        }

    }
</script>

<style lang="css" scoped > 
    @import "../styles/modal.min.css"; 
</style>



// WEBPACK FOOTER //
// src/pages/General/Users/modals/Auth.vue